// Master slugs are persisted. Variant address titles come from the API's base-title projection.
export function buildProductPath(slug: string, searchParams?: URLSearchParams): string {
  return appendProductQuery(`/products/${encodeURIComponent(slug)}`, searchParams);
}

export function buildVariantPath(masterSlug: string, variantAddressTitle: string, searchParams?: URLSearchParams): string {
  return appendProductQuery(`${buildProductPath(masterSlug)}/${encodeURIComponent(variantAddressTitle)}`, searchParams);
}

function appendProductQuery(path: string, searchParams?: URLSearchParams): string {
  const query = new URLSearchParams(searchParams);
  query.delete("masterProductId");
  const suffix = query.toString();
  return `${path}${suffix ? `?${suffix}` : ""}`;
}
